import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"
import { copyText, fill } from "../../lib/format"

// CommonMark plus GitHub tables and fenced code, converted as you type.
export default class extends Controller {
  static targets = ["source", "output", "copy", "status"]
  static values = { messages: Object }

  connect() {
    marked.use({ gfm: true, breaks: false })
    this.convert()
  }

  convert() {
    const source = this.sourceTarget.value
    this.outputTarget.value = source.trim() ? marked.parse(source) : ""
    const lines = this.outputTarget.value ? this.outputTarget.value.trim().split("\n").length : 0
    this.statusTarget.textContent = lines ? fill(lines === 1 ? this.messagesValue.lines_one : this.messagesValue.lines_other, { count: lines }) : ""
  }

  copy() {
    copyText(this.outputTarget.value, this.copyTarget, this.messagesValue)
  }

  clear() {
    this.sourceTarget.value = ""
    this.convert()
    this.sourceTarget.focus()
  }
}
